export default __webpack_public_path__ + "static/media/OpelNextBold.12772300.otf";